<template>
    <div class="">
       
        <l-project-configuration-privacy v-model="project" @mouseenter="showPrivacyMessage" @mouseleave="hidePrivacyMessage" @click="togglePrivacyMessage"/>

        <div v-if="errorsOnSave" class="validationErrors px-5">
            <div class="notification is-danger is-light">
                <button class="delete" @click="errorsOnSave = false"></button>
                <p class="has-text-weight-bold is-size-6 pb-2">
                    {{ $t('project.errors_on_save') }}
                </p>
                <p class="is-size-6">
                    {{ $t('project.errors_on_save_desc') }}
                </p>
                <br />
                <p class="is-size-6 has-text-italic" v-for="(error, index) in projectErrors" :key="index">
                    - {{ error }}
                </p>
            </div>
        </div>

        <div class="action-buttons-container mb-2">
            <a @click="discardUnsavedChanges" class="button is-primary">
                <span class="icon is-small my-2"><i class="mdi mdi-32px mdi-chevron-double-left"
                        aria-hidden="true"></i></span>
            </a>
            <a :disabled="!hasChanges" @click="saveChanges"
                class="button is-primary primary-font is-size-5 is-pulled-right mr-5">
                {{ $t('Buttons.save') }}
            </a>
        </div>
    </div>
</template>

<script>
import LProjectConfigurationPrivacy from '@/components/LProjectConfigurationPrivacy';
import _ from 'underscore';

export default {
    components: {
        LProjectConfigurationPrivacy,
    },
    props: {
        
    },
    mounted() {
    },
    data() {
        return {
            project: this.projectSource,
            saving: false,
            pendingChanges: false,
            errorsOnSave: false,
            projectErrors: {},
            showBackground: false,
            originalProvider: '',
            overlayImage: undefined,
            originalOverlay: { ...this.$store.state.project.overlay } || {
                image: {},
                opacity: 100,
            },

        };
    },
    computed: {
        hasAdminPermission() {
            return this.$store.getters.project.accessLevel == 'administrator';
            // return true;
        },
        hasEditPermission() {
            return this.$store.getters.project.accessLevel == 'edit';
            // return true;
        },
        canEdit() {
            return this.hasAdminPermission || this.hasEditPermission;
            // return true;
        },
        hasChanges() {
            return (
                !_.isEqual(this.project, this.$store.state.project) ||
                !_.isEqual(this.project.mapProvider, this.originalProvider) ||
                !_.isEqual(this.project.overlay, this.originalOverlay)
            );
        },
        projectSource() {
            // console.log(this.$store.getters.project);
            const proj = this.$store.getters.project;
            if (
                this.hasAdminPermission &&
                !this.$store.getters.project.folder
            ) {
                proj.folder = {};
                //return proj;
            }
            if (!this.$store.getters.project.mapProvider) {
                proj.mapProvider = 'OpenStreetMap 2';
            }
            if (this.originalProvider == '') {
                this.originalProvider = proj.mapProvider;
            }
            if (!this.$store.getters.project.overlay) {
                // console.log('assigning default overlay');
                proj.overlay = {
                    image: {},
                    opacity: 100,
                };
            } else {
                if (
                    this.$store.getters.project.overlay.image &&
                    Object.keys(this.$store.getters.project.overlay.image)
                        .length > 0
                ) {
                    this.overlayImage =
                        this.$store.getters.project.overlay.image;
                }
            }
            return proj;
        },
        availableProviders() {
            return _.filter(this.tileProviders, (provider) => {
                return provider.image;
            });
        },
        activeProvider() {
            return this.project.mapProvider || 'OpenStreetMap 2';
        },
        canSetBackground() {
            return this.project.mode != 'map' && this.project.type != 'scape' && this.project.type != 'treasurehunt';
        },
        canSetOverlayImage() {
            return this.project.type == 'scape' && this.project.mode == 'map';
        },
        canSetBaseMap() {
            return this.project.mode == 'map' || this.project.type == 'treasurehunt';
        },
    },
    watch: {
        projectSource: {
            handler: function () {
                this.project = JSON.parse(JSON.stringify(this.projectSource));
                // console.log('changes in project', this.project);
            },
            immediate: true,
        },
        overlayImage: {
            handler: function () {
                // console.log('change image', this.overlayImage);

                // this.project.overlayImage = this.overlayImage;
                if (
                    this.overlayImage &&
                    (!this.project.overlay || !this.project.overlay.image)
                ) {
                    // console.log('adding new overlay image');
                    this.project.overlay.image = this.overlayImage;
                    this.$emit('drawOverlayImage', this.overlayImage);
                } else if (this.overlayImage && this.project.overlay.image) {
                    // console.log('updating overlay image');
                    if (
                        !_.isEqual(
                            this.overlayImage,
                            this.project.overlay.image
                        )
                    ) {
                        this.project.overlay.image = this.overlayImage;
                        this.project.overlay.opacity = 100;
                        this.$emit('updateOverlayImage', this.overlayImage);
                    }
                } else {
                    // console.log('removing overlay image',this.overlayImage);
                    this.project.overlay.image = {};
                    this.project.overlay.opacity = 100;
                    this.$emit('removeOverlayImage', this.overlayImage);
                }
            },
        },
    },
    methods: {
        isActive(option) {
            if (this.$refs[option]) {
                if (this.$refs[option].classList.contains('is-active')) {
                    this.$refs[`${option}-icon`].childNodes[0].classList.remove(
                        'fa-caret-up'
                    );
                    this.$refs[`${option}-icon`].childNodes[0].classList.add(
                        'fa-caret-down'
                    );
                } else {
                    this.$refs[`${option}-icon`].childNodes[0].classList.remove(
                        'fa-caret-down'
                    );
                    this.$refs[`${option}-icon`].childNodes[0].classList.add(
                        'fa-caret-up'
                    );
                }
            }
        },
        saveChanges() {
            // console.log('project data to save', this.project);
            this.saving = true;
            if (!this.project.title) {
                this.projectErrors['title'] = this.$t(
                    `project.missing_title_value`
                );
            }

            if (this.project.type == 'scape') {
                if (
                    !this.project.overlay.image ||
                    Object.keys(this.project.overlay.image).length === 0
                ) {
                    this.projectErrors['overlay'] = this.$t(
                        `project.missing_overlay_value`
                    );
                }
            }

            const isValid = Object.keys(this.projectErrors).length === 0;
            // console.log('project errors', this.projectErrors);
            if (isValid) {
                if (_.isEmpty(this.project.folder)) {
                    delete this.project.folder;
                }
                this.$emit('updateProject', this.project);
                this.saving = false;
            } else {
                this.saving = false;
                this.errorsOnSave = true;
            }
        },
        discardUnsavedChanges() {
            if (this.hasChanges) {
                // console.log('discarding changes');
                this.$emit('discardChanges');
            }
            this.$emit('close');
        },
        changeProvider(provider) {
            if (
                this.project.mapProvider !== provider.name ||
                !this.project.mapProvider
            ) {
                this.project.mapProvider = provider.name;
                this.$emit('changeTileProvider', provider);
            }
        },
        showPrivacyMessage() {
            // console.log("showing")
            this.$emit('showPrivacyMessage');
        },
        hidePrivacyMessage() {
            // console.log("hiding")
            this.$emit('hidePrivacyMessage');
        },
        togglePrivacyMessage() {
            this.$emit('togglePrivacyMessage');
        }
    },
};
</script>

<style scoped>
@import '~vue-slider-component/theme/default.css';
@import '../assets/css/leftPanel.css';

.message {
    background-color: transparent;
    border-radius: 0;
    font-size: 1rem;
    margin-bottom: 0;
}

.message-header {
    border-radius: 0;
    padding-right: 0;
    background-color: #f4f4f4;
    border-bottom: 1px solid #d2d2d2;
}

.lb-accordion {
    overflow-y: auto;
    max-height: calc(100vh - 13rem);
    overflow-x: hidden;
}

.message a:not(.button):not(.lb-button):not(.lb-toolbar-button_images):not(.lb-toolbar-button_video):not(.lb-toolbar-button_files):not(.lb-toolbar-button_audio):not(.lb-toolbar-button_url):not(.lb-toolbar-button_location):not(.lb-toolbar-button_tags):not(.lb-toolbar-button_question):not(.lb-toolbar-button_object):not(.lb-toolbar-button_point):not(.lb-delete-media):not(.lb-answer):not(.lb-multiple-answer):not(.tag):not(.lb-bain-tag-functional):not(.lb-bain-tag-emotional):not(.lb-bain-tag-life-changer):not(.lb-bain-tag-social-impact):not(.lb-role-tag_administrator):not(.lb-role-tag_teacher):not(.lb-role-tag_student):not(.lb-role-tag_coordinator):not(.lb-role-tag_participant):not(.lb-role-tag_facilitator):not(.lb-status-tag_active):not(.lb-status-tag_inactive):not(.lb-status-tag_invited):not(.dropdown-item) {
    text-decoration: none;
}

.message-body.is-collapsible {
    overflow-x: hidden;
}

.action-buttons {
    position: absolute;
    bottom: 11px;
    width: 100%;
    left: 10px;
}

.action-buttons button {
    height: 60px;
}

.validationErrors {
    position: absolute;
    z-index: +1;
    top: 20%;
}

.validationErrors .notification {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}


</style>